import { Component, EventEmitter, OnInit } from '@angular/core';
import { SpinnerService } from '~shared/components/buttons/spinner/spinner.service';
import { ModalOptions } from './modal-options';
import { ModalService } from './modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: 'modal.component.html'
})

export class ModalComponent implements OnInit {
  public spinnerName: string = 'modalSubmit';
  public isOpen: boolean;
  public modalOptions: ModalOptions;

  public submitClicked: EventEmitter<any> = new EventEmitter(null);
  public cancelClicked: EventEmitter<any> = new EventEmitter(null);

  constructor(
    private modalService: ModalService,
    private spinnerService: SpinnerService,
  ) {
    this.modalService.castIsOpen.subscribe(status => this.isOpen = status);
    this.modalService.castModalOptions.subscribe(modalOptions => this.modalOptions = modalOptions);
  }

  ngOnInit(): void { }

  public setModalStatus(status: boolean): void {
    this.modalService.setStatus(status);
  }

  get showSpinner(): boolean {
    return this.spinnerService.isShowing(this.spinnerName);
  }

  public submitButtonClicked(): void {
    this.modalService.submitButtonClicked();
  }

  public cancelButtonClicked(): void {
    this.modalService.cancelButtonClicked();
    this.setModalStatus(false);
  }
}
